module.exports = "/lucky-balls/img/orange-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/orange-ball.png
// module id = 101
// module chunks = 0